import styles from "./chip.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import { useEffect } from "react";
import { useRef } from "react";
gsap.registerPlugin(ScrollTrigger);

const Chip = () => {
  const ctnRef = useRef(null);
  const imgBoxRef = useRef(null);
  const imgRef = useRef(null);
  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: imgBoxRef.current,
        start: "top center",
        scrub: 0.6,
        end: "top top",
      },
    });

    // tl.to(imgBoxRef.current, {
    //   width: "100vw",
    //   height: "100vh",
    // });

    //   tl2.to(imgBoxRef.current,{
    //       width:'100vw',
    //       height:'100vh'
    //   })
  });
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={styles.textBox}>
        <h6 className="mainText">算法</h6>
        <h2>十代核心算法。</h2>
        <h5>
          第十代蜂巢稳控算法，
          <span>
            精细剔除运镜中的细微频率抖动，根据摄影师常用场景和运镜习惯重新调教跟随曲线和平滑曲线
          </span>
          ，进一步提升视频拍摄稳控性能和顺滑程度；同时，配合轴臂空间和搭载相机，WEEBILL
          3带来极佳舒适的拍摄感受。
        </h5>
      </div>
      <img className={styles.img} src="./wb3-1.png" alt="" ref={imgRef} />
    </div>
  );
};

export default Chip;
